<template>
  <receipt-detail :token="token" :receiptValue="receipt" :myUserId="myId" v-if="showCapture" @receiptMoreLike="receiptMoreLike"></receipt-detail>
  <receipt-force v-if="showForcing" :receiptData="tableData" @back="navBackHandle" @submitForce="submitForce"></receipt-force>
  <reward-page-detail v-if="showReward" :receiptValue="receipt" :myUserId="myId" :token="token" @receiptMoreLike="receiptRewardMoreLike"></reward-page-detail>
  <receipt-reward-force v-if="showRewardForcing" :receiptData="tableData" @back="navBackHandle" @submitForce="submitRewardForce"></receipt-reward-force>
  <van-overlay :show="loading">
      <van-loading class="wrapper" color="#1989fa" >
      </van-loading>
  </van-overlay>
</template>

<script>
import ReceiptDetail from './components/pages/ReceiptDetail.vue';
import { inject } from 'vue'
import { FReceiptPassForce, receiptDetail, userLoginByOpenId,receiptRewardDetail } from './utils/methodCenter';
import { showDialog } from 'vant';
import ReceiptForce from './components/pages/ReceiptForce.vue';
import RewardPageDetail from './components/pages/RewardPageDetail.vue';
import ReceiptRewardForce from './components/pages/ReceiptRewardForce.vue';
export default {
  name: 'App',
  components: {
    ReceiptDetail,
    ReceiptForce,
    RewardPageDetail,
    ReceiptRewardForce
  },
  setup(){
    const myData = inject('myData')
    return { myData }
  },
  data() {
    return {
      showCapture: true, // 显示付款收款单页面
      imgUrl: '',
      datetime: '',
      mobile:'',
      city:'',
      firsttime: '',
      weekendtime: '',
      location: '',
      pics:'',
      receipt: {},
      token: '',
      myId: '',
      loading: false,
      showReward: false, // 显示报销单
      showRewardForcing:false,// 是否报销单审核的冲突显示提示
      showForcing:false,// 是否显示提示
      receiptValues: {}, // 审核通过提交的数据
      tableData:{},// 冲突表单的数据
    }
  },
  mounted() {
    const isRelease = process.env.NODE_ENV === 'production' ? true : false;
    // let result = {"data":{"applyAt":1684053363984,"applyAtDate":"2023-05-14","applyAtDesc":"2023-05-14 16:36:03","attachFiles":"https://hans.pdmarket.cn/crmres/微信图片_20230515170358_1686152683522_308.jpg","companyName":"上海信智船务有限公司","currencyName":"RMB","customName":"PICC PROPERTY AND CASUALTY COMPANY LIMITED SHANGHAI BRANCH","flowUserIcon":"https://hans.pdmarket.cn/crmres/response0_1678108888873_3876.png","flowUserId":1,"flowUserLoginName":"admin","flowUserNickName":"admin","gatheredTotal":30920.00000000,"id":917,"isPay":0,"isSelfClose":0,"receiptRate":7.00000000,"receiptType":1,"remarks":"1212","shipName":"Christina ocean","submitAt":1687681840045,"submitAtDate":"2023-06-25","submitAtDesc":"2023-06-25 16:30:40","submitUserIcon":"https://hans.pdmarket.cn/crmres/response0_1678108888873_3876.png","submitUserId":1,"submitUserLoginName":"admin","submitUserNickName":"admin","submitUserRoleIds":[2],"tableToc":{"cells":[{"content":"123","fundCategory":"5501.18-赔偿费用","orgGathered":30920,"orgPay":10,"usdGathered":4417.142857142857,"usdPay":1.4285714285714286},{"content":"33","fundCategory":"5101.06-租金收入","orgGathered":20,"orgPay":10,"usdGathered":2.857142857142857,"usdPay":1.4285714285714286}],"gatheredTotal":30920,"orgGatheredTotal":30940,"orgPayTotal":20,"usdGatheredTotal":4420,"usdPayTotal":2.857142857142857},"verifyStatus":10,"verifyStatusDesc":"审核被驳回","voyagesName":"V20050"},"errCode":0,"errMsg":"成功","isNeedParse":0,"totalSize":0}
    let rewardresult = {"data":{"applyAt":1700916591502,"applyAtDate":"2023-11-25","applyAtDesc":"2023-11-25 20:49:51","attachFiles":"https://hans.pdmarket.cn/crmres/微信图片_20231008120429_1700571018974_5775.jpg","companyName":"MANDARINE OCEAN LTD","flowUserIcon":"https://hans.pdmarket.cn/crmres/response0_1678108888873_3876.png","flowUserId":1,"flowUserLoginName":"admin","flowUserNickName":"admin","id":477,"isPay":0,"isSelfClose":0,"receiptType":3,"remarks":"测试测试","submitAt":1700571081511,"submitAtDate":"2023-11-21","submitAtDesc":"2023-11-21 20:51:21","submitUserIcon":"https://hans.pdmarket.cn/crmres/response0_1678108888873_3876.png","submitUserId":1,"submitUserLoginName":"admin","submitUserNickName":"admin","submitUserRoleIds":[2],"tableToc":{"cells":[{"content":"测试内容","fundCategory":"2205-税金及其他","payAmount":120},{"content":"测试内容","fundCategory":"2207-分红支出","payAmount":111}],"totalMoney":231.00000000},"totalMoney":231.00000000,"verifyStatus":4,"verifyStatusDesc":"公司批复"},"errCode":0,"errMsg":"成功","isNeedParse":0,"totalSize":0}

    if(!isRelease){
      this.receipt = rewardresult.data
      console.log('this.receipt:', rewardresult.data)
      this.showReward = true
      this.showCapture = false
    }else{
      this.loading = true
      userLoginByOpenId(this.myData.code).then((result) => {
        if(result.data.errCode>0){
          this.loading = false
          showDialog({
            message: result.data.errMsg,
            confirmButtonText: '刷新页面'
          }).then(() => {
            // on close
            window.location.href = 'https://mobile.pdmarket.cn/openidIndex.html?id='+this.myData.receiptId + '&type='+this.myData.type
          });
          return
        }
        // let temp = {"data":{"createAt":1672636492184,"createAtDesc":"2023-01-02 13:14:52","icon":"https://hans.pdmarket.cn/crmres/response0_1678108888873_3876.png","id":1,"lastLoginAt":1672636492184,"lastLoginAtDesc":"2023-01-02 13:14:52","loginName":"admin","nickName":"admin","roleIds":[1],"status":0,"token":"EBnRBceHLA","tokenExpireAt":1686382416181,"tokenExpireAtDesc":"2023-06-10 15:33:36"},"errCode":0,"errMsg":"成功","isNeedParse":0,"totalSize":0}
        // result = temp
        // console.log(result.data.id, result.data.token)
        let resultt = result.data.data
        // 我的id
        this.myId = resultt.id
        // 订单类型
        this.type = resultt.receiptType
        // 我的token
        this.token = resultt.token
        this.refreshReceipt()
      })
    }
  },
  methods: {
    refreshReceipt:function(){
      console.log('refreshReceipt:', this.myData.type)
      if(this.myData.type==3){
        receiptRewardDetail(this.myData.receiptId).then((result)=>{
          if(result.data.errCode > 0){
            this.loading = false
            showDialog({
              message: result.data.errMsg,
              confirmButtonText: '刷新页面'
            }).then(() => {
              // on close
              window.location.href = 'https://mobile.pdmarket.cn/openidIndex.html?id='+this.myData.receiptId + '&type='+3
            });
            return
          }
          this.loading = false
          this.showReward = true
          this.showCapture = false
          this.receipt = result.data.data
          console.log('receiptRewardDetail end1:',this.myId,this.token, this.receipt)
        })
      }else{
        receiptDetail(this.myData.receiptId?this.myData.receiptId:1073).then((result)=>{
          console.log('receiptDetail:',this.myId,this.token, result.data)
          if(result.data.errCode > 0){
            this.loading = false
            showDialog({
              message: result.data.errMsg,
              confirmButtonText: '刷新页面'
            }).then(() => {
              // on close
              window.location.href = 'https://mobile.pdmarket.cn/openidIndex.html?id='+this.myData.receiptId + '&type='+1
            });
            return
          }
          this.loading = false
          this.showCapture = true
          this.showReward = false
          this.receipt = result.data.data
          console.log('receiptDetail end1:',this.myId,this.token, this.receipt)
        })
      }
    },
    navBackHandle:function(){
      // this.showForcing = false
      // this.showCapture = true
    },
    receiptMoreLike:function(values_, tableData_){
      this.showForcing = true
      this.showCapture = false
      this.receiptValues=values_
      this.tableData = tableData_
    },
    // 报销单重复
    receiptRewardMoreLike:function(values_, tableData_){
      this.showRewardForcing = true
      this.showCapture = false
      this.showReward = false
      this.receiptValues=values_
      this.tableData = tableData_
    },
    // 强制通过报销单
    submitRewardForce:function(){
      this.loading = true
      this.navBackHandle();
      FReceiptPassForce(this.receiptValues).then((res)=>{
        this.showRewardForcing = false
        this.loading = false
        console.log(res)
        this.refreshReceipt()
      })
    },
    // 强制通过付款单
    submitForce:function(){
      this.loading = true
      this.navBackHandle();
      FReceiptPassForce(this.receiptValues).then((res)=>{
        this.showForcing = false
        this.loading = false
        console.log(res)
        this.refreshReceipt()
      })
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
  overflow: hidden;
}

.captureStyle{
  width: 100%;
}

.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
</style>
